import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import RequireAuth, { RequireAdminAuth } from '@/components/feature/RequireAuth';
import WorkspaceGuard from '@/pages/admin-workspace/components/WorkspaceGuard';

const HomeEntryGuard = lazy(() => import('../pages/home/HomeEntryGuard'));
const TrainingPage   = lazy(() => import('../pages/training/page'));
const PayrollPage    = lazy(() => import('../pages/payroll/page'));
const InteractionPage = lazy(() => import('../pages/interaction/page'));
const ReportPage     = lazy(() => import('../pages/report/page'));
const ReportsPage    = lazy(() => import('../pages/reports/page'));
const LoginPage      = lazy(() => import('../pages/login/page'));
const NotFoundPage   = lazy(() => import('../pages/NotFound'));
const DashboardPage  = lazy(() => import('../pages/dashboard/page'));
const CrmPage        = lazy(() => import('../pages/crm/page'));
const ProjectPage    = lazy(() => import('../pages/project/page'));
const MaterialPage   = lazy(() => import('../pages/material/page'));
const SharePreviewPage = lazy(() => import('../pages/share/page'));
const AdminPage      = lazy(() => import('../pages/admin/page'));
const SplashPage     = lazy(() => import('../pages/splash/page'));
const AdminLoginPage = lazy(() => import('../pages/admin-login/page'));
const TenantOpsPage  = lazy(() => import('../pages/ops/page'));
const AdminWorkspaceLoginPage = lazy(() => import('../pages/admin-workspace/login/page'));
const AdminWorkspacePage = lazy(() => import('../pages/admin-workspace/page'));

const routes: RouteObject[] = [
  // ── Public routes ──────────────────────────────────────
  { path: '/login',       element: <LoginPage /> },
  { path: '/admin/login', element: <AdminLoginPage /> },
  { path: '/splash',      element: <SplashPage /> },
  { path: '/share/:id',   element: <SharePreviewPage /> },

  // ── 官方工作台（独立路由，保密链接）──────────────────────
  { path: '/admin-workspace/login', element: <AdminWorkspaceLoginPage /> },
  {
    path: '/admin-workspace',
    element: <WorkspaceGuard><AdminWorkspacePage /></WorkspaceGuard>,
  },
  {
    path: '/admin-workspace/interaction',
    element: <WorkspaceGuard><AdminWorkspacePage /></WorkspaceGuard>,
  },
  {
    path: '/admin-workspace/crm',
    element: <WorkspaceGuard><AdminWorkspacePage /></WorkspaceGuard>,
  },
  {
    path: '/admin-workspace/material',
    element: <WorkspaceGuard><AdminWorkspacePage /></WorkspaceGuard>,
  },

  // ── Smart entry: new-user → splash, logged-in → interaction, returning-guest → login ──
  { path: '/', element: <HomeEntryGuard /> },

  // ── Protected routes (require login) ──────────────────
  {
    path: '/admin',
    element: <RequireAdminAuth><AdminPage /></RequireAdminAuth>,
  },
  {
    path: '/admin/tenant-ops/:tenantId',
    element: <RequireAdminAuth><TenantOpsPage /></RequireAdminAuth>,
  },
  {
    path: '/interaction',
    element: <RequireAuth><InteractionPage /></RequireAuth>,
  },
  {
    path: '/crm',
    element: <RequireAuth><CrmPage /></RequireAuth>,
  },
  {
    path: '/reports',
    element: <RequireAuth><ReportsPage /></RequireAuth>,
  },
  {
    path: '/report',
    element: <RequireAuth><ReportPage /></RequireAuth>,
  },
  {
    path: '/payroll',
    element: <RequireAuth><PayrollPage /></RequireAuth>,
  },
  {
    path: '/training',
    element: <RequireAuth><TrainingPage /></RequireAuth>,
  },
  {
    path: '/dashboard',
    element: <RequireAuth><DashboardPage /></RequireAuth>,
  },
  {
    path: '/project',
    element: <RequireAuth><ProjectPage /></RequireAuth>,
  },
  {
    path: '/material',
    element: <RequireAuth><MaterialPage /></RequireAuth>,
  },

  { path: '*', element: <NotFoundPage /> },
];

export default routes;
